import { Tabs, TabsListProps } from '@chakra-ui/react';
import { forwardRef, ReactNode } from 'react';
import { withPositionalTabValues } from './withPositionalTabValues';

export interface MTabListProps extends TabsListProps {
  children?: ReactNode;
}

/*
 * v3's `Tabs.Trigger` requires an explicit `value` prop — v2's `TabList`
 * assigned each tab a position-based index implicitly. This reproduces that:
 * each child gets `value={String(position)}` unless it already provides its
 * own (an escape hatch, not the common case). Works uniformly for `MTab` and
 * `MCustomLinkTab` alike, since both forward `value` through to a real
 * `Tabs.Trigger` underneath.
 */
export const MTabList = forwardRef<HTMLDivElement, MTabListProps>(
  ({ children, ...rest }, ref) => (
    <Tabs.List ref={ref} {...rest}>
      {withPositionalTabValues(children)}
    </Tabs.List>
  ),
);

MTabList.displayName = 'MTabList';

export default MTabList;
